import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { Button } from '@flipster/react/design-system';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { TradingLeaderboardEvent } from '@flipster/utils/segment/events/trading-leaderboard';

import { SegmentPage } from '../../../../misc/segment/segment-page';
import { entryPopupItemBunja } from '../../bunja';
import { leagueLeaderboardOnboardingBunja } from './bunja';
import LeaderboardOnboardingImage from './img_leaderboard_onboarding.webp';

export const LeagueLeaderboardOnboardingModal = () => {
  const { onClose: close, markAsRead } = useBunja(entryPopupItemBunja);
  const { descriptionsAtom } = useBunja(leagueLeaderboardOnboardingBunja);
  const descriptions = useAtomValue(descriptionsAtom);
  function onClose() {
    markAsRead('RECURRING_TC_OPEN');
    close();
  }
  return (
    <>
      <SegmentPage name={TradingLeaderboardEvent.LeagueOnboardingView} context={{ event_location: 'leaderboard' }} />
      <Modal>
        <Modal.Close onClose={onClose} />
        <Modal.Header css={{ textStyle: 'Title/M', color: 'content.default.level-4' }}>
          You’ve joined the league
        </Modal.Header>
        <Modal.Content css={stack.raw({ gap: { base: 24, tablet: 16 } })}>
          <img
            src={LeaderboardOnboardingImage.src}
            alt='Tap to view leagues'
            className={css({
              border: '1px solid',
              borderColor: 'border.default.level-2',
              rounded: 8,
            })}
          />
          <div className={stack({ textStyle: 'Text/L/Regular', color: 'content.default.level-3', gap: 16 })}>
            <p>
              You’re placed into weekly and monthly leagues based on your asset balance. Keep trading to climb higher.
            </p>
            <div className={stack({ gap: 2 })}>
              <p className={css({ textStyle: 'Text/L/Strong' })}>League tiers</p>
              {descriptions && (
                <ul className={css({ ml: 24, '&, & > li': { listStyle: 'disc' } })}>
                  {descriptions.map(([label, description]) => (
                    <li key={label}>
                      {label}: {description}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </Modal.Content>
        <Modal.Footer>
          <Button
            size='large'
            label='View my rank'
            onClick={() => {
              segment.track(TradingLeaderboardEvent.LeagueOnboardingClick, {
                event_location: 'leaderboard',
              });
              onClose();
            }}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};
